import declare from "dojo/_base/declare";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import _ from "lodash";
import RefImageContainer from "csi/heading/RefImageContainer";
import { cnl } from "c8-platform";

// Define the class using TypeScript syntax
const CareBySalesRegionIconContainer = declare(RefImageContainer, {
	bBaseRenderer: true,

	/**
		 * Extract attribute value
		 * @param {Context} ctx
		 * @param {Heading} h
		 */
	getReferencedNodes(ctx: Context, h: Heading): cnl[] {
		// default processing
		const imageNodeUrls: cnl[] = [];

		const languageNode = ctx.getNode();
		const careInstructions = ctx.cache.getNodes(ctx.getParent().CareInstructions);

		careInstructions.forEach((care) => {
			if (care && !_.isEmpty(care.LanguageIcons)) {
				const iconUrl = care.LanguageIcons[languageNode.SysID];
				if (iconUrl) {
					imageNodeUrls.push(iconUrl);
				}
			}
		});

		return imageNodeUrls;
	},
});

export = CareBySalesRegionIconContainer;